import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  Response,
  TQueryParams,
  formatQueryParams,
  parseJsonApiResponse,
  prepareHeaders,
} from 'evolve-ui';

export type TDistrict = {
  id: string;
  name: string;
};

export const districtsApi = createApi({
  reducerPath: 'districts',
  baseQuery: fetchBaseQuery({
    // TODO: change to countries api url
    baseUrl: `${process.env.GATSBY_OFFERS_API_URL}/districts`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['District'],
  endpoints: (builder) => ({
    getDistricts: builder.query<Response<TDistrict>, TQueryParams>({
      providesTags: ['District'],
      query: formatQueryParams,
      transformResponse: parseJsonApiResponse<TDistrict>,
    }),
  }),
});

export const { useGetDistrictsQuery } = districtsApi;
